import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Earthquake/FeatureServer/1&source=sd)
 *  */
const EARTHQUAKE_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.00073,
  colors.amber[300],
  0.00236,
  colors.orange[500],
  0.0052,
  colors.red[500],
  0.0081,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Earthquake/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 0.0081 – 0.00999", 11],
    ["> 0.0052 – 0.0081", 9],
    ["> 0.00236 – 0.0052", 7],
    ["> 0.00073 – 0.00236", 5],
    ["0 – 0.00073", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: EARTHQUAKE_STOPS[row[1] as number],
  }));
};

export const earthquakes = {
  stops: EARTHQUAKE_STOPS,
  props: getLegendRows(),
};
